var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wrap result-wrap result-wrap-o" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _vm.type === "loading"
          ? [
              _c("div", { staticClass: "icon loading" }),
              _c("div", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.$t("loginning"))),
              ]),
            ]
          : _vm.type === "success"
          ? [
              _c(
                "div",
                { staticClass: "user-list" },
                _vm._l(_vm.userList, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.uid,
                      staticClass: "item",
                      class: { active: item.uid === _vm.crtUser.uid },
                      on: {
                        click: function ($event) {
                          _vm.crtUser = item
                        },
                      },
                    },
                    [
                      _c("div", {
                        staticClass: "avatar",
                        style: { backgroundImage: `url(${item.avatar})` },
                      }),
                      _c("div", { staticClass: "right" }, [
                        _c("div", { staticClass: "row top" }, [
                          _c("div", { staticClass: "name" }, [
                            _vm._v(_vm._s(item.name)),
                          ]),
                          _c("div", {
                            staticClass: "date",
                            domProps: {
                              innerHTML: _vm._s(
                                item.last_login.split(" ").join("<br />")
                              ),
                            },
                          }),
                        ]),
                        _c("div", { staticClass: "row info" }, [
                          _c("div", { staticClass: "txt" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("userinfo_level", { 0: item.level })
                              )
                            ),
                          ]),
                          _c("div", { staticClass: "txt" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("userinfo_server", { 0: item.server })
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _c(
                "Button",
                {
                  attrs: { type: "warning", disabled: !_vm.crtUser.uid },
                  on: { click: _vm.loginClick },
                },
                [_vm._v(_vm._s(_vm.$t("test_confirm")) + " ")]
              ),
            ]
          : _vm.type === "fail"
          ? [
              _c("div", { staticClass: "icon fail" }),
              _c("div", { staticClass: "text" }, [
                _vm._v(" " + _vm._s(_vm.$t("login_fail_2")) + " "),
                _vm.code > 0
                  ? _c("p", { staticClass: "code-tips" }, [
                      _vm._v(
                        _vm._s(_vm.code) +
                          " - " +
                          _vm._s(
                            _vm.urlParams.gid === "60004" && _vm.code === 20016
                              ? _vm.$t("ENTROPY_20016")
                              : _vm.$t(`KGSDK_${_vm.code}`)
                          )
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm.type === "fail"
      ? _c(
          "div",
          { staticClass: "btns" },
          [
            _c(
              "Button",
              { attrs: { type: "warning" }, on: { click: _vm.reLogin } },
              [_vm._v(_vm._s(_vm.$t("try_again")) + " ")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }